module.exports = {
  MENSAGENS: require('@/domain/enums/Mensagens').default,
  MATCH_NETWORK_ERROR: /NETWORK ERROR/,

  getServiceUrl() {
    if (process.env.VUE_APP_IS_GATEWAY === 'false') {
      let serviceNoGateway =
        process.env.VUE_APP_API_PROTOCOL +
        process.env.VUE_APP_API_HOST +
        ':' +
        process.env.VUE_APP_API_PORT +
        process.env.VUE_APP_API_BASE_URL;
      return serviceNoGateway;
    }
    let serviceIsGateway =
      process.env.VUE_APP_API_GATEWAY_URL +
      '/' +
      process.env.VUE_APP_API_GATEWAY_URL_API
    return serviceIsGateway;
  },
  getBasicToken() {
    return "Basic " + process.env.VUE_APP_API_GATEWAY_BASIC_TOKEN;
  },
  getServiceUrlGateway() {
    let serviceUrlGateway =
      process.env.VUE_APP_API_GATEWAY_URL
    return serviceUrlGateway;
  },
  trataErrorHttpResponse(e) {
    if (e.response) {
      if (e.response.status === 403) {
        return this.MENSAGENS.ACESSO_NEGADO;
      } else if (e.response.status === 404) {
        return this.MENSAGENS.APLICACAO_INDISPONIVEL;
      } else if (e.response.status === 503) {
        return this.MENSAGENS.SERVICO_TEMPORARIAMENTE_INDISPONIVEL;
      } else if (e.response.status === 500) {
        return this.MENSAGENS.ERRO_INTERNO;
      }
    } else if (e.message.toUpperCase().match(this.MATCH_NETWORK_ERROR)) {
      return this.MENSAGENS.APLICACAO_INDISPONIVEL;
    }
  },
  /**
   * Função para validar se roles do usuario
   * @param {*} role nome da role que deseja validar
   */
  hasRole(role) {
    if (
      localStorage.getItem('user_roles') != null &&
      localStorage.getItem('user_roles') !== ''
    ) {
      var roles = localStorage.getItem('user_roles').split(',');
      return roles.indexOf(role) > -1;
    }
    return false;
  },
  hasAnyRole(roles) {
    for (let i = 0; i < roles.length; i++) {
      let result = this.hasRole(roles[i]);
      if (result) {
        return result;
      }
    }
    return false;
  },
  isAuthenticated() {
    let accessToken = localStorage.getItem('cod_consultor');
    return this.isNotBlank(accessToken);
  },

  // verifica tempo de sessão do usuário.
  sessaoExpirada() {
    let dtUltimaRequisicaoLocalStorage = localStorage.getItem(
      'dt_ultima_requisicao'
    );
    if (this.isBlank(dtUltimaRequisicaoLocalStorage)) {
      return false;
    }
    var dtUltimaRequisicao = Number(dtUltimaRequisicaoLocalStorage);
    var dtAtual = new Date().getTime();

    var difference = dtAtual - dtUltimaRequisicao; // retorna a diferenca em segundos
    var resultInMinutes = Math.round(difference / 60000); // converte os segundos em minutos

    let resultado = resultInMinutes > process.env.VUE_APP_TEMPO_INATIVIDADE;

    if (resultado) {
      var data = new Date(dtUltimaRequisicao);
      console.log(
        'data/hora da ultima requisicao: ' +
          data.toLocaleDateString() +
          ' ' +
          data.toLocaleTimeString()
      );
    }

    return resultado;
  },

  isBlank(value) {
    if (value == null || value.toString().trim().length === 0) {
      return true;
    }
    return false;
  },
  isNotBlank(value) {
    return !this.isBlank(value);
  },
  getEnumByPropertieValue(enumType, propName, propValue) {
    for (let enumeration in enumType) {
      let obj = enumType[enumeration];
      for (let prop in obj) {
        if (propName === prop) {
          let value = obj[prop];
          if (propValue === value) {
            return obj;
          }
        }
      }
    }
    return null;
  },
  getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  },
  setCookie(cname, cvalue, exdays = null) {
    let host = process.env.VUE_APP_API_PROTOCOL + process.env.VUE_APP_HOST;
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    if (exdays === null) {
      window.document.cookie = cname + '=' + cvalue + '; path=' + host + '/;';
    } else {
      window.document.cookie =
        cname +
        '=' +
        cvalue +
        ';' +
        expires +
        '; secure ; httponly; path=' +
        host +
        '/;';
    }
  },
  /**
   * Ao fazer pesquisa utilizando o recurso de regex aplicado na String alguns
   * caracteres não são levados em conta, por isso devemos realizar o escape
   * desses caracteres.
   * @param {*} str
   */
  escapeSpecialCharacter(str) {
    return str
      .replace(/\\/g, '\\\\')
      .replace(/\+/g, '\\+')
      .replace(/\./g, '\\.')
      .replace(/\[/g, '\\[')
      .replace(/\]/g, '\\]')
      .replace(/\^/g, '\\^')
      .replace(/\$/g, '\\$')
      .replace(/\(/g, '\\(')
      .replace(/\)/g, '\\)')
      .replace(/\?/g, '\\?')
      .replace(/\*/g, '\\*')
      .replace(/\|/g, '\\|')
      .replace(/\{/g, '\\{')
      .replace(/\}/g, '\\}')
      .replace(/\//g, '\\/');
  },
};